<template>
  <div v-if="enabled" class="add-mode" role="status">
    <span class="material-icons add-mode__icon" aria-hidden="true">add_location_alt</span>
    <div class="add-mode__text">
      <strong class="text-yellow">{{ $t('waypoint_adding_mode_notificaiton.waypoint_adding_notification.add_waypoint') }}</strong>
      <small>{{ $t('waypoint_adding_mode_notificaiton.waypoint_adding_notification.select_where_you_wish_to_add') }}</small>
    </div>
    <button type="button" class="btn btn-link add-mode__exit" @click="disableAddingWaypointsMode">
      {{ $t('waypoint_adding_mode_notificaiton.waypoint_adding_notification.exit') }}
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </div>
</template>

<script>

import { defineComponent } from 'vue';
import { applyWaypointAddingCursor } from './waypointAddingCursor';

export default defineComponent({
  computed: {
    // Read straight from the store so every host map gets the banner without having to wire it up.
    enabled() {
      return Boolean(this.$store.state.waypoints?.waypointAddingModeEnabled);
    },
  },
  watch: {
    enabled: {
      handler(enabled) {
        applyWaypointAddingCursor(enabled);
      },
      immediate: true,
    },
  },
  beforeUnmount() {
    applyWaypointAddingCursor(false);
  },
  methods: {
    disableAddingWaypointsMode() {
      this.$store.commit('waypoints/setWaypointAddingMode', false);
    },
  },
});

</script>

<style scoped>
  /* Centred under the map's Maps/Options buttons — the one spot clear of every host's side panels. */
  .add-mode {
    position: absolute;
    top: 108px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 101;
    display: flex;
    align-items: center;
    gap: 12px;
    /* Without this, left: 50% leaves only half the map's width to size into. */
    width: max-content;
    max-width: calc(100% - 32px);
    padding: 10px 8px 10px 14px;
    background-color: rgba(0, 0, 0, 0.85);
    border-radius: 12px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
  }
  .add-mode__icon {
    color: var(--yellow);
    font-size: 26px;
  }
  .add-mode__text {
    display: flex;
    flex-direction: column;
    line-height: 1.3;
    color: #fff;
  }
  .add-mode__exit {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 8px;
    white-space: nowrap;
  }
</style>

<style>
  /* Pin cursor, hotspot at its tip. Waypoint hover still sets an inline `pointer` on the canvas,
     which wins, so existing waypoints still read as clickable. */
  body.waypoint-adding-mode .mapboxgl-canvas-container.mapboxgl-interactive,
  body.waypoint-adding-mode .mapboxgl-canvas-container.mapboxgl-interactive:active {
    cursor: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='36' viewBox='0 0 28 36'%3E%3Cpath d='M14 1.5C7.1 1.5 1.5 7 1.5 13.8c0 9.2 12.5 20.7 12.5 20.7s12.5-11.5 12.5-20.7C26.5 7 20.9 1.5 14 1.5z' fill='%23fddf00' stroke='%23111' stroke-width='2'/%3E%3Cpath d='M14 8.5v10M9 13.5h10' stroke='%23111' stroke-width='2.4' stroke-linecap='round'/%3E%3C/svg%3E") 14 34, crosshair;
  }
</style>
